module.exports = __webpack_public_path__ + "img/logo-company-test.d9026498.svg";